(function () {
  'use strict';

  function closeAll(except) {
    document.querySelectorAll('[data-ccy-select]').forEach(function (root) {
      if (root === except) return;
      var list = root.querySelector('[data-ccy-list]');
      var backdrop = root.querySelector('[data-ccy-backdrop]');
      var trigger = root.querySelector('[data-ccy-trigger]');
      if (list) list.hidden = true;
      if (backdrop) backdrop.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function initInstance(root) {
    if (root.getAttribute('data-ccy-init') === 'true') return;
    root.setAttribute('data-ccy-init', 'true');

    var trigger = root.querySelector('[data-ccy-trigger]');
    var triggerLabel = root.querySelector('[data-ccy-trigger-label]');
    var isIconMode = root.classList.contains('ccy-select--icon');
    var list = root.querySelector('[data-ccy-list]');
    var backdrop = root.querySelector('[data-ccy-backdrop]');
    var nativeSelect = root.querySelector('[data-ccy-native]');
    if (!trigger || !list || !nativeSelect) return;

    // Move the dropdown out to <body>. If a fixed-position ancestor (e.g. the
    // mobile header, which has its own CSS transform for the hide-on-scroll
    // animation) has a `transform`, it becomes the containing block for any
    // `position: fixed` descendant per spec — breaking the list's viewport
    // centering. Detaching it avoids that entirely.
    document.body.appendChild(list);
    if (backdrop) document.body.appendChild(backdrop);

    function open() {
      closeAll(root);
      list.hidden = false;
      if (backdrop) backdrop.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }

    function close() {
      list.hidden = true;
      if (backdrop) backdrop.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function (event) {
      event.stopPropagation();
      if (list.hidden) {
        open();
      } else {
        close();
      }
    });

    if (backdrop) {
      backdrop.addEventListener('click', close);
    }

    var options = list.querySelectorAll('[data-ccy-option]');
    for (var i = 0; i < options.length; i++) {
      options[i].addEventListener('click', function (event) {
        var option = event.currentTarget;
        var value = option.getAttribute('data-value');

        if (nativeSelect.value !== value) {
          nativeSelect.value = value;
          nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        var labelEl = option.querySelector('.ccy-select__option-label');
        if (triggerLabel) {
          if (isIconMode) {
            triggerLabel.textContent = option.getAttribute('data-symbol') || (labelEl ? labelEl.textContent : '');
          } else if (labelEl) {
            triggerLabel.textContent = labelEl.textContent;
          }
        }

        close();
      });
    }

    document.addEventListener('click', function (event) {
      if (!list.hidden && !root.contains(event.target) && !list.contains(event.target)) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !list.hidden) close();
    });
  }

  function init() {
    var roots = document.querySelectorAll('[data-ccy-select]');
    for (var i = 0; i < roots.length; i++) initInstance(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
